export default __webpack_public_path__ + "3d4add935b01f1a16c89cea37e9dad01.svg";